import {registerIconLibrary} from '@web.awesome.me/webawesome-pro/dist/webawesome.js';

/**
 * Bootstrap Icons CDN base. The Goodvantage frontends use Bootstrap Icon names
 * (inherited from Shoelace, whose default icon library was Bootstrap Icons).
 * Pinned to a fixed version for stable, reproducible icon rendering.
 */
const BOOTSTRAP_ICONS_BASE = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons';

/**
 * Web Awesome defaults its icon set to Font Awesome, which uses different icon
 * names than the Bootstrap Icons the apps were built against. Overriding the
 * "default" icon library to resolve Bootstrap Icons keeps every existing
 * `<wa-icon name="...">` working unchanged after the Shoelace -> Web Awesome
 * migration.
 *
 * Call once during application bootstrap, before the first icon renders.
 */
export function registerWebawesomeIcons(): void {
  registerIconLibrary('default', {
    resolver: (name: string) => `${BOOTSTRAP_ICONS_BASE}/${name}.svg`,
  });
}
